import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import { colorList } from '@/model/dataLayer/api/dish/Category'
import { saveFile } from '@/model/utils/utils'

const path = 'api/membership-systems/'

const entity = {
  description: {
    header: false,
    formConfig: {
      required: false
    }
  },
  image: {
    header: false,
    type: IKDataEntity.Types.Image,
    tableConfig: {
      required: false
    }
  },
  imageDisplay: {
    displayName: 'image',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  name: {},
  color: {
    type: IKDataEntity.Types.Color,
    formConfig: {
      default: colorList[Math.round(Math.random() * 18)],
      required: false
    },
    header: false,
    tableConfig: { filterable: false }
  },
  // levelOrder: {
  //   displayName: '等级顺序',
  //   formConfig: {
  //     hint: '等级顺序'
  //   }
  // },
  requiredPoints: {
    displayName: '所需积分',
    formConfig: {
      hint: '所需积分'
    }
  },
  checkDetail: {
    displayName: 'detail',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}

const config = {
  load: async function (filter) {
    const systemId = GlobalConfig.systemId
    const response = await hillo.get(cloudV2Url + path + systemId + '/levels')

    // Check if response is an array before calling map
    if (!response || !Array.isArray(response)) {
      console.warn('Membership levels response is not an array:', response)
      return []
    }

    return response.map(it => {
      it.name = it.displayInfo.name
      it.color = it.displayInfo.color
      it.image = it.displayInfo.imageUrl
      it.description = it.displayInfo.description
      return it
    })
  },
  add: async function (item) {
    const systemId = GlobalConfig.systemId
    item.displayInfo = {
      name: item.name,
      description: item.description,
      imageUrl: item.files ? await saveFile(item.file) : '',
      color: item.color
    }
    item.levelOrder = 0
    item.membershipSystemId = systemId
    return (await hillo.jsonPost(cloudV2Url + path + systemId + '/levels', {
      ...item
    })).content
  },
  edit: async function (item) {
    const systemId = GlobalConfig.systemId
    item.displayInfo = {
      name: item.name,
      description: item.description,
      imageUrl: item.file ? await saveFile(item.file) : item.image,
      color: item.color
    }
    return (await hillo.jsonPost(cloudV2Url + path + systemId + '/levels/' + item.id, {
      ...item
    })).content
  },
  remove: async function (id) {
    const systemId = GlobalConfig.systemId
    return (await hillo.jsonPost(cloudV2Url + path + systemId + '/levels/' + id + '/delete', {
    }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)
